import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/Equipmentmanagement-removebg.png'
import _imports_1 from '@/assets/cliqueD1.png'
import _imports_2 from '@/assets/cliqueD2.png'
import _imports_3 from '@/assets/factory-group.png'
import _imports_4 from '@/assets/factory-machine-1.png'
import _imports_5 from '@/assets/factory-machine-2.png'


const _hoisted_1 = {
  id: "mainBox2",
  class: "p-4 min-h-[50px]",
  style: {"background-color":"#080718ff"}
}
const _hoisted_2 = {
  class: "flex items-center mt-4",
  style: {"background-color":"#080718ff"}
}
const _hoisted_3 = { style: {"color":"#ffffffff"} }
const _hoisted_4 = {
  key: 0,
  class: "w-full flex dashboard-layout dashboard-shell",
  style: {"background-color":"#080718ff","color":"#fff","min-height":"92vh"}
}
const _hoisted_5 = { class: "flex flex-col dashboard-col dashboard-col-left" }
const _hoisted_6 = {
  class: "flex flex-col mt-2 w-full rounded-lg factory-scope-card",
  style: {"background":"#171325ff","padding":"4px","box-shadow":"0 2px 8px rgba(0, 0, 0, 0.08)","border":"none"}
}
const _hoisted_7 = { class: "flex items-center justify-between ml-4 mt-4 mb-4" }
const _hoisted_8 = { style: {"font-size":"20px","font-weight":"400","color":"#b1afafff","margin":"0"} }
const _hoisted_9 = { style: {"background":"#fff","padding":"8px","border-radius":"4px","font-size":"12px","color":"#1a202c"} }
const _hoisted_10 = { style: {"margin-bottom":"4px"} }
const _hoisted_11 = { style: {"margin-bottom":"4px"} }
const _hoisted_12 = { style: {"margin-bottom":"4px"} }
const _hoisted_13 = { class: "grid grid-cols-1 gap-2" }
const _hoisted_14 = { style: {"font-size":"12px","color":"#b1b1b1","font-weight":"500","margin-bottom":"4px","letter-spacing":"0.5px"} }
const _hoisted_15 = { class: "flex items-end justify-between" }
const _hoisted_16 = { style: {"font-size":"28px","font-weight":"700","color":"#10b981","line-height":"1"} }
const _hoisted_17 = { style: {"font-size":"12px","color":"#b1b1b1","margin-top":"4px"} }
const _hoisted_18 = { style: {"font-size":"12px","color":"#b1b1b1","font-weight":"500","margin-bottom":"4px","letter-spacing":"0.5px"} }
const _hoisted_19 = { class: "flex items-end justify-between" }
const _hoisted_20 = { style: {"font-size":"28px","font-weight":"700","color":"#3b82f6","line-height":"1"} }
const _hoisted_21 = { style: {"font-size":"12px","color":"#b1b1b1","margin-top":"4px"} }
const _hoisted_22 = { style: {"font-size":"12px","color":"#b1b1b1","font-weight":"500","margin-bottom":"4px","letter-spacing":"0.5px"} }
const _hoisted_23 = { class: "flex items-end justify-between" }
const _hoisted_24 = { style: {"font-size":"28px","font-weight":"700","color":"#a855f7","line-height":"1"} }
const _hoisted_25 = { style: {"font-size":"11px","color":"#b1b1b1","margin-top":"4px"} }
const _hoisted_26 = {
  class: "flex flex-col mt-6 w-full rounded-lg factory-operation-card",
  style: {"background":"#171325ff","padding":"20px","box-shadow":"0 2px 8px rgba(0, 0, 0, 0.08)","border":"none","min-height":"300px"}
}
const _hoisted_27 = {
  class: "ml-4 mt-4 mb-4",
  style: {"font-size":"20px","font-weight":"400","color":"#b1afafff","margin":"0"}
}
const _hoisted_28 = { class: "grid grid-cols-2 gap-6 mt-6" }
const _hoisted_29 = { class: "flex items-start justify-between" }
const _hoisted_30 = { style: {"font-size":"12px","color":"#92400e","font-weight":"500","margin-bottom":"8px","letter-spacing":"0.5px"} }
const _hoisted_31 = { style: {"font-size":"24px","font-weight":"700","color":"#d97706","line-height":"1.2"} }
const _hoisted_32 = { style: {"background":"#fff","padding":"8px","border-radius":"4px","font-size":"12px","color":"#1a202c"} }
const _hoisted_33 = { class: "flex items-start justify-between" }
const _hoisted_34 = { style: {"font-size":"12px","color":"#065f46","font-weight":"500","margin-bottom":"8px","letter-spacing":"0.5px"} }
const _hoisted_35 = { style: {"font-size":"32px","font-weight":"700","color":"#10b981","line-height":"1"} }
const _hoisted_36 = { style: {"font-size":"12px","color":"#059669","margin-top":"4px"} }
const _hoisted_37 = { style: {"background":"#fff","padding":"8px","border-radius":"4px","font-size":"12px","color":"#1a202c"} }
const _hoisted_38 = { class: "flex flex-col dashboard-col dashboard-col-middle" }
const _hoisted_39 = {
  class: "flex-col mt-2 w-full rounded-xl factory-health-card",
  style: {"color":"#b1afafff","background-color":"#171325ff"}
}
const _hoisted_40 = { class: "flex items-center ml-4 mt-4 mb-4" }
const _hoisted_41 = { style: {"font-size":"20px"} }
const _hoisted_42 = { class: "w-full" }
const _hoisted_43 = { class: "w-full flex" }
const _hoisted_44 = {
  key: 0,
  class: "mr-5"
}
const _hoisted_45 = { class: "w-full flex items-center" }
const _hoisted_46 = {
  key: 0,
  style: {"width":"240px","height":"240px"},
  id: "chartA"
}
const _hoisted_47 = { class: "ml-4" }
const _hoisted_48 = { class: "ml-2" }
const _hoisted_49 = { class: "ml-2" }
const _hoisted_50 = { class: "ml-2" }
const _hoisted_51 = { class: "ml-2" }
const _hoisted_52 = {
  class: "flex-col mt-6 w-full rounded-xl factory-alarm-record-card",
  style: {"min-height":"400px","color":"#b1afafff","background-color":"#171325ff"}
}
const _hoisted_53 = { class: "flex items-center ml-4 mt-4 mb-4" }
const _hoisted_54 = { style: {"font-size":"20px"} }
const _hoisted_55 = { class: "w-full flex items-center mt-7" }
const _hoisted_56 = { class: "w-full ml-2 mr-2 mb-4 mt-1" }
const _hoisted_57 = {
  class: "w-full flex items-center",
  style: {"background-color":"#080718ff"}
}
const _hoisted_58 = {
  class: "table-info",
  style: {"opacity":"0.6"}
}
const _hoisted_59 = {
  class: "table-info",
  style: {"opacity":"0.6"}
}
const _hoisted_60 = {
  class: "table-info",
  style: {"opacity":"0.6"}
}
const _hoisted_61 = {
  class: "table-info",
  style: {"opacity":"0.6"}
}
const _hoisted_62 = ["title"]
const _hoisted_63 = { class: "table-info" }
const _hoisted_64 = { class: "table-info" }
const _hoisted_65 = {
  class: "flex flex-col ml-3 factory-zone-col",
  style: {"width":"700px"}
}
const _hoisted_66 = {
  class: "flex-col w-full rounded-xl factory-zone-card",
  style: {"min-height":"750px","color":"#b1afafff","background-color":"#171325ff"}
}
const _hoisted_67 = { class: "flex items-center ml-4 mt-4 mb-4" }
const _hoisted_68 = { style: {"font-size":"20px"} }
const _hoisted_69 = { class: "w-full flex items-center flex-wrap" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { class: "w-full flex items-center" }
const _hoisted_72 = ["title"]
const _hoisted_73 = { class: "content flex items-center w-full" }
const _hoisted_74 = {
  class: "w-full flex items-center",
  style: {"text-align":"left"}
}
const _hoisted_75 = { style: {"width":"160px"} }
const _hoisted_76 = { class: "size14 opc8" }
const _hoisted_77 = {
  class: "size18",
  style: {"color":"#06DEF5"}
}
const _hoisted_78 = { style: {"width":"160px"} }
const _hoisted_79 = { class: "size14 opc8" }
const _hoisted_80 = {
  class: "size18",
  style: {"color":"#06DEF5"}
}
const _hoisted_81 = {
  class: "w-full flex items-center",
  style: {"text-align":"left"}
}
const _hoisted_82 = { style: {"width":"160px"} }
const _hoisted_83 = { class: "size14 opc8" }
const _hoisted_84 = {
  class: "size18",
  style: {"color":"#5BFEB7"}
}
const _hoisted_85 = { style: {"width":"160px"} }
const _hoisted_86 = { class: "size14 opc8" }
const _hoisted_87 = {
  class: "size18",
  style: {"color":"#5BFEB7"}
}
const _hoisted_88 = {
  class: "w-full flex items-center",
  style: {"text-align":"left"}
}
const _hoisted_89 = { style: {"width":"160px"} }
const _hoisted_90 = { class: "size14 opc8" }
const _hoisted_91 = {
  class: "size18",
  style: {"color":"#B81212"}
}
const _hoisted_92 = { style: {"width":"160px"} }
const _hoisted_93 = { class: "size14 opc8" }
const _hoisted_94 = {
  class: "size18",
  style: {"color":"#DDD246"}
}
const _hoisted_95 = {
  key: 1,
  class: "w-full flex dashboard-layout-alt dashboard-shell",
  style: {"background-color":"#080718ff","color":"#fff","min-height":"92vh"}
}
const _hoisted_96 = { class: "flex flex-col mt-2 dashboard-alt-left" }
const _hoisted_97 = {
  class: "flex-col w-full rounded-xl",
  style: {"color":"#b1afafff","background-color":"#171325ff"}
}
const _hoisted_98 = { class: "flex items-center ml-4 mt-4 mb-4" }
const _hoisted_99 = { style: {"font-size":"20px"} }
const _hoisted_100 = { class: "w-full flex items-center mt-4 ml-4" }
const _hoisted_101 = { class: "flex-col w-full" }
const _hoisted_102 = { class: "ml-1" }
const _hoisted_103 = { class: "ml-1" }
const _hoisted_104 = { class: "flex-col w-full" }
const _hoisted_105 = { class: "ml-1" }
const _hoisted_106 = { class: "ml-1" }
const _hoisted_107 = { class: "mt-4 mb-4 flex items-center zone-radar-row" }
const _hoisted_108 = { class: "zone-radar-item" }
const _hoisted_109 = {
  key: 0,
  id: "chart2A",
  class: "zone-radar-chart"
}
const _hoisted_110 = {
  class: "mt-4",
  style: {"text-align":"center"}
}
const _hoisted_111 = { class: "zone-radar-item" }
const _hoisted_112 = {
  key: 0,
  id: "chart2B",
  class: "zone-radar-chart"
}
const _hoisted_113 = {
  class: "mt-4",
  style: {"text-align":"center"}
}
const _hoisted_114 = { class: "flex flex-col mt-2 dashboard-alt-middle" }
const _hoisted_115 = {
  class: "flex-col w-full rounded-xl",
  style: {"color":"#b1afafff","background-color":"#171325ff"}
}
const _hoisted_116 = { class: "flex items-center ml-4 mt-4 mb-4" }
const _hoisted_117 = { style: {"font-size":"20px"} }
const _hoisted_118 = {
  class: "flex-col w-full rounded-xl mt-6",
  style: {"color":"#b1afafff","background-color":"#171325ff"}
}
const _hoisted_119 = { class: "flex items-center ml-4 mt-4 mb-4" }
const _hoisted_120 = { style: {"font-size":"20px"} }
const _hoisted_121 = { class: "w-full mb-4" }
const _hoisted_122 = {
  class: "w-full flex items-center",
  style: {"background-color":"#080718ff"}
}
const _hoisted_123 = {
  class: "table-info",
  style: {"opacity":"0.6"}
}
const _hoisted_124 = {
  class: "table-info",
  style: {"opacity":"0.6"}
}
const _hoisted_125 = {
  class: "table-info",
  style: {"opacity":"0.6"}
}
const _hoisted_126 = {
  class: "table-info",
  style: {"opacity":"0.6"}
}
const _hoisted_127 = ["title"]
const _hoisted_128 = { class: "table-info" }
const _hoisted_129 = { class: "table-info" }
const _hoisted_130 = { class: "dashboard-alt-right" }
const _hoisted_131 = {
  class: "flex-col w-full rounded-xl mt-2",
  style: {"color":"#b1afafff","background-color":"#171325ff"}
}
const _hoisted_132 = { class: "flex items-center ml-4 mt-2 mb-4" }
const _hoisted_133 = { style: {"font-size":"20px"} }
const _hoisted_134 = { class: "flex items-center" }
const _hoisted_135 = { class: "ml-2" }
const _hoisted_136 = { class: "flex items-center" }
const _hoisted_137 = { class: "ml-2" }
const _hoisted_138 = { class: "flex items-center" }
const _hoisted_139 = { class: "ml-2" }
const _hoisted_140 = { class: "w-ful mt-5 mb-6 box3" }
const _hoisted_141 = { class: "w-full flex items-center" }
const _hoisted_142 = {
  class: "ml-2",
  style: {"font-size":"16px"}
}
const _hoisted_143 = {
  class: "ml-2",
  style: {"font-size":"12px"}
}
const _hoisted_144 = { class: "flex items-center flex-wrap mb-4" }
const _hoisted_145 = ["onClick"]
const _hoisted_146 = { class: "w-full flex items-center" }
const _hoisted_147 = ["title"]
const _hoisted_148 = ["onClick"]
const _hoisted_149 = ["onClick"]
const _hoisted_150 = {
  class: "w-full flex items-center",
  style: {"margin-top":"5px"}
}
const _hoisted_151 = {
  class: "flex-1 flex",
  style: {"justify-content":"center"}
}
const _hoisted_152 = ["src"]
const _hoisted_153 = { style: {"margin-left":"15px"} }
const _hoisted_154 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_155 = { class: "text-gray-50 pl-2" }
const _hoisted_156 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_157 = { class: "text-gray-50 pl-2" }
const _hoisted_158 = { class: "flex items-center mt-2" }
const _hoisted_159 = { class: "text-gray-50 pl-2" }
const _hoisted_160 = {
  class: "w-full items-center flex",
  style: {"margin-top":"5px"}
}
const _hoisted_161 = { key: 0 }
const _hoisted_162 = {
  key: 1,
  class: "ml-2",
  style: {"color":"#03b503ff"}
}
const _hoisted_163 = ["title"]
const _hoisted_164 = { class: "w-full items-center flex" }
const _hoisted_165 = {
  class: "ml-2",
  style: {"color":"#03b503ff"}
}
const _hoisted_166 = {
  class: "ml-2",
  style: {"color":"#03b503ff"}
}
const _hoisted_167 = { style: {"margin-top":"20px","padding-top":"12px","border-top":"1px solid #333"} }

import { defineComponent, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import { useRouter } from "vue-router";
import request from "../../common/request";
import { transformDate } from "../../common/tools";
import { v4 as uuidv4 } from "uuid";
import * as echarts from "echarts";
import pictureListComponent from "../components/picture-list.vue";
import { langList } from "../../common/lang";
import { getRealFactoryIdListById, getGroupListByFactory } from "../../common/tools";
import { getLanguage, getTranslation } from "@/common/translate"

export default /*@__PURE__*/_defineComponent({
  __name: 'factory',
  setup(__props) {

const router = useRouter()
// Dashboard display for area or device view     1: area / 2: device
let selectModel = ref(1)

let factory_id = ''
let factoryList: any = ref([])
let isShowFac = ref(false)
let totalTime = ref(0)
let weightedAverage: any = ref(0)
let groupList: any = ref([])
let machineList: any = ref([])
let sensorList: any = ref([])
let langObj: any = ref({})
let language: any = ref('English')
const getLang = () => {
     language.value = 'English'
    langObj.value = langList[language.value]
}
getLang()

let conditionSelectFac: any = ref('')
let conditionChartData: any = ref([      // Equipment health status statistics data
    { label: langObj.value['健康'], num: 0, color: '#61c08f' },
    { label: langObj.value['可用'], num: 0, color: '#706a00ff' },
    { label: langObj.value['警戒'], num: 0, color: '#cd5f3b' },
    { label: langObj.value['故障'], num: 0, color: '#921e37' },
])
let machineWarningData: any = ref([])

let listSelectFac: any = ref('')
let listSelectGroup: any = ref('')

let value = ref('')

let visibleChart1 = ref(true)
let visibleChart2 = ref(true)



onMounted(() => {
    getLang()
    init()
    window.addEventListener('resize', resizeZoneRadarCharts)
})

onUnmounted(() => {
    window.removeEventListener('resize', resizeZoneRadarCharts)
})

const resizeZoneRadarCharts = () => {
    const chartIds = ['chart2A', 'chart2B']
    chartIds.forEach((id) => {
        const dom = document.getElementById(id)
        if (!dom) return
        const chart = echarts.getInstanceByDom(dom as HTMLDivElement)
        if (chart) {
            chart.resize()
        }
    })
}

const init = () => {
    factory_id = localStorage.getItem('factory_id') || ''
    loadFactory()
}

// Get factory list
const loadFactory = async () => {
    let groupInfo = getGroupListByFactory()
    let groups: any = []
    factoryList.value = []
    const config = {
        headers: {
            requestId: uuidv4(),
        },
    };

    let result = await request.get("/api/factories", config)
    if (result.data && result.data.length) {
        if (!factory_id) {
            const fallbackFactory = result.data.find((p: any) => !p.parentId) || result.data[0]
            if (fallbackFactory?._id) {
                factory_id = fallbackFactory._id
                localStorage.setItem('factory_id', factory_id)
            }
        }

        conditionSelectFac.value = factory_id
        listSelectFac.value = factory_id

        factoryList.value = result.data.filter((p: any) => p._id === factory_id || p.parentId === factory_id)
        if(factoryList.value?.length > 1) {
            isShowFac.value = true
        }

        // Get runtime
        totalTime.value = 0
        let facL = factoryList.value.filter((p: any) => p.parentId === factory_id)
        if (facL && facL.length) {
            let time: any = 0
            facL.map((d: any) => {
                let targetTime: any = new Date(d.createAt); // Assume the target time is 2023-07-16 12:00:00 UTC
                let currentTime: any = new Date(); // Current time
                let time2 = Math.floor(
                    (currentTime - targetTime) / (1000 * 60 * 60)
                );
                if (time2 > time) {
                    time = time2
                }
            })
            totalTime.value = time

        } else {
            let info = factoryList.value.find((p: any) => p._id === factory_id) || result.data[0]
            if (!info?.createAt) {
                totalTime.value = 0
            } else {
                let targetTime: any = new Date(info.createAt); // Assume the target time is 2023-07-16 12:00:00 UTC
                let currentTime: any = new Date(); // Current time
                totalTime.value = Math.floor(
                    (currentTime - targetTime) / (1000 * 60 * 60)
                );
            }
        }

        result.data.forEach((element: any) => {
            element.groups = element.groups.map((t: any) => ({
                ...t,
                Name: element.factoryName + "-" + t.name,
            }));
            // groupInfo
            let groupss = element.groups.filter((p:any) => groupInfo.find((g:any) => g.id === p.sonID))
            if(groupss?.length > 0) {
                groups = groups.concat(groupss);
            }
        });

        getMain(groups);
    }
}


// Get area list
const getMain = async (groups: any) => {
    const config = {
        params: {
            factoryIds: getRealFactoryIdListById(factory_id) 
        },
        headers: {
            requestId: uuidv4(),
        },
    };
    let result = await request.get("/api/external/machines/workstatus", config)

    weightedAverage.value = 0
    groupList.value = [];
    machineList.value = [];
    sensorList.value = [];

    if (result && result.data) {
        let faultResult = await request.post('/api/faultinfos', { FeatureType: '' })
        result.data.map((d: any) => {
            let sz = 100000000000
            let temp = 100000000000
            d.quota && d.quota.map((q: any) => {
                if (q.values && q.values.length) {
                    let szInfo = q.values.find((p: any) => p.type === '速度Z')
                    if (szInfo) {
                        if (szInfo.value <= sz) {
                            sz = szInfo.value
                        }
                    }
                    let tempInfo = q.values.find((p: any) => p.type === '温度')
                    if (tempInfo) {
                        if (tempInfo.value <= temp) {
                            temp = tempInfo.value
                        }
                    }
                }
            })

            d.temp = temp == 100000000000 ? 0.00 : temp?.toFixed(2)
            d.sz = sz == 100000000000 ? 0 : sz

            let faultTitle = '设备运行正常'
            if (d.workStableStatus && d.workStableStatus.scores && Object.values(d.workStableStatus.scores).length) {
                let score = 100
                let name = ''
                for (let i in d.workStableStatus.scores) {
                    let value = d.workStableStatus.scores[i]
                    if (value <= score) {
                        score = value
                        name = i
                    }
                }
                faultTitle = faultResult.data.find((p: any) => p.scoreName === name)?.faultName
            }
            d.faultTitle = faultTitle
        })



        let weightAll = 0
        let count = 0
        groups.forEach((item2: any) => {
            item2.machines = result.data.filter(
                (t2: any) => t2.groupId == item2.sonID
            );
            item2.machines.map((d: any) => {
                sensorList.value = sensorList.value.concat(d.sensors)
                if (!d.workStatus) {
                    d.workStatus = {
                        condition: 0,
                        wkStatus: 0
                    }
                }
                if (!d.workStableStatus) {
                    d.workStableStatus = {
                        condition: 0,
                        wkStatus: 0
                    }
                }

                if (d.workStableStatus.condition === 0) {
                    weightAll = weightAll + 100
                }
                if (d.workStableStatus.condition >= 1 && d.workStableStatus.condition <= 2) {
                    weightAll = weightAll + 80
                }
                if (d.workStableStatus.condition >= 3 && d.workStableStatus.condition <= 5) {
                    weightAll = weightAll + 60
                }
                if (d.workStableStatus.condition >= 6 && d.workStableStatus.condition <= 7) {
                    weightAll = weightAll + 30
                }
                count++
                
            })
            machineList.value = machineList.value.concat(item2.machines)
            groupList.value.push(item2)
        })
        weightedAverage.value = count ? (weightAll / count).toFixed(2) : 0
    }


    setTimeout(() => {
        getConditionChartData()
        getMachineWarningChartData()
        getGroupListDetail()
    }, 500);

}

// Get operating device count and operating rate
const getRunMachine = (ev: any) => {
    let num: any = 0
    let rate: any = 0
    if (ev && ev.length) {
        ev.map((d: any) => {
            if (d.workStatus.wkStatus) {
                num++
            }
        })
        rate = ((num / ev.length) * 100).toFixed(2)
    }

    return { num, rate }
}

// Get equipment health status statistics / equipment operating status statistics data
const getConditionChartData = () => {
    let n1 = 0, n2 = 0, n3 = 0, n4 = 0
    let facList = factoryList.value.filter((p: any) => p.parentId && p.parentId === conditionSelectFac.value)
    if (facList.length) {
        facList.map((f: any) => {
            f.groups && f.groups.map((g: any) => {
                g.machines && g.machines.map((m: any) => {
                    if (m.workStableStatus.condition === 0) {
                        n1++
                    }
                    if (m.workStableStatus.condition >= 1 && m.workStableStatus.condition <= 2) {
                        n2++
                    }
                    if (m.workStableStatus.condition >= 3 && m.workStableStatus.condition <= 5) {
                        n3++
                    }
                    if (m.workStableStatus.condition >= 6 && m.workStableStatus.condition <= 7) {
                        n4++
                    }
                })
            })
        })
    } else {
        let f = factoryList.value.find((p: any) => p._id === conditionSelectFac.value)
        f?.groups && f.groups.map((g: any) => {
            g.machines && g.machines.map((m: any) => {
                if (m.workStableStatus.condition === 0) {
                    n1++
                }
                if (m.workStableStatus.condition >= 1 && m.workStableStatus.condition <= 2) {
                    n2++
                }
                if (m.workStableStatus.condition >= 3 && m.workStableStatus.condition <= 5) {
                    n3++
                }
                if (m.workStableStatus.condition >= 6 && m.workStableStatus.condition <= 7) {
                    n4++
                }
            })
        })
    }


    conditionChartData.value = [
        { label: langObj.value['健康'], num: n1, color: '#61c08f' },
        { label: langObj.value['可用'], num: n2, color: '#706a00ff' },
        { label: langObj.value['警戒'], num: n3, color: '#cd5f3b' },
        { label: langObj.value['故障'], num: n4, color: '#921e37' },
    ]

    initConditionChart()
}

// Draw the equipment health status chart
const initConditionChart = () => {
    if (!document.getElementById("chartA")) return
    let myChart = echarts.init(document.getElementById("chartA") as HTMLDivElement);

    let DData = conditionChartData.value.map((t: any) => ({
        value: t.num,
        name: t.label
    }))
    const total = conditionChartData.value.reduce((sum: number, item: any) => sum + item.num, 0)

    let options = {
        tooltip: {
            show: true,
            trigger: "item",
            backgroundColor: "rgba(10, 14, 34, 0.95)",
            borderColor: "rgba(255, 255, 255, 0.15)",
            textStyle: { color: "#ffffff" },
            formatter: "{b}<br/>{c} ({d}%)",
        },
        graphic: [
            {
                type: "text",
                left: "center",
                top: "44%",
                style: {
                    text: langObj.value["总设备数"],
                    textAlign: "center",
                    fontSize: 12,
                    fill: "rgba(255, 255, 255, 0.7)",
                    fontWeight: 500,
                },
            },
            {
                type: "text",
                left: "center",
                top: "52%",
                style: {
                    text: String(total),
                    textAlign: "center",
                    fontSize: 28,
                    fill: "#ffffff",
                    fontWeight: 700,
                },
            },
        ],
        series: [
            {
                type: "pie",
                radius: ["58%", "87%"],
                center: ["50%", "50%"],
                silent: true,
                label: { show: false },
                data: [{ value: 1, itemStyle: { color: "rgba(255,255,255,0.10)" } }],
            },
            {
                name: "",
                type: "pie",
                radius: ["61%", "82%"],
                center: ["50%", "50%"],
                avoidLabelOverlap: true,
                padAngle: 1,
                minAngle: 3,
                itemStyle: {
                    borderColor: "transparent",
                    borderWidth: 0,
                    borderRadius: 1,
                },
                label: { show: false },
                emphasis: {
                    scale: true,
                    scaleSize: 4,
                },
                labelLine: { show: false },
                data: DData,
            },
        ],
        color: ['rgb(28, 196, 139)', 'rgb(206, 224, 8)', 'rgb(223, 87, 45)', 'rgb(162, 3, 53)']
    };

    myChart.setOption(options);
    myChart.off("mouseover");
    myChart.off("mouseout");
    myChart.on("mouseover", (params: any) => {
        if (!params?.name) return;
        options.graphic[0].style.text = params.name;
        options.graphic[1].style.text = String(params.value ?? 0);
        myChart.setOption(options);
    });
    myChart.on("mouseout", () => {
        options.graphic[0].style.text = langObj.value["总设备数"];
        options.graphic[1].style.text = String(total);
        myChart.setOption(options);
    });

}

// 获取设备报警记录
let warningTypeList = [
    { label: '智能诊断', value: 1 },
    { label: '门限报警', value: 4 },
]
const getMachineWarningChartData = async () => {
    machineWarningData.value = []
    let facList = factoryList.value.filter((p: any) => p.parentId && p.parentId === factory_id)
    let factoryIds = []
    if (facList && facList.length) {
        factoryIds = facList.map((p: any) => p._id)
    } else {
        factoryIds = [factory_id]
    }
    let config: any = {
        params: {
            skip: 1,
            take: 7,
            factoryIds,
            typeList: [1, 4]
        },

        headers: {
            requestId: uuidv4(),
        },
    };

    let result = await request.get('/api/workflows', config)

    if (result && result.data) {
        machineWarningData.value = result.data.list
        machineWarningData.value.map((d: any) => {
            d.date = d.date.substring(5, 16)
        })
    }
}

// 获取严重程度名称颜色
const getMachineWarningName = (condition: any) => {
    let name = '健康'
    let color = '#61c08f'
    if (condition >= 1 && condition <= 2) {
        name = '可用'
        color = '#706a00ff'
    }
    if (condition >= 3 && condition <= 5) {
        name = '警戒'
        color = '#cd5f3b'
    }
    if (condition >= 6 && condition <= 7) {
        name = '故障'
        color = '#921e37'
    }

    return { name, color }
}

// 获取区域清单
let groupListData: any = ref([])
let groupList2: any = ref([{ name: langObj.value['全部区域'], sonID: '' }])
const getGroupListDetail = async () => {
    if (!listSelectFac.value) {
        groupListData.value = []
        groupList2.value = [{ name: langObj.value['全部区域'], sonID: '' }]
        return
    }

    let facList = factoryList.value.filter((p: any) => p.parentId && p.parentId === listSelectFac.value)
    let factoryIds = []
    if (facList && facList.length) {
        factoryIds = facList.map((p: any) => p._id)
    } else {
        factoryIds = [listSelectFac.value]
    }
    groupList2.value = [{ name: langObj.value['全部区域'], sonID: '' }]
    //获取未处理事件
    let config: any = {
        params: {
            skip: 1,
            take: 1000000,
            factoryIds,
            typeList: [1],
            handleStatus: 1,
        },

        headers: {
            requestId: uuidv4(),
        },
    };

    let result = await request.get('/api/workflows', config)
    let noHandeleList: any = []
    if (result && result.data && result.data.list) {
        noHandeleList = result.data.list
    }

    let groList: any = []
    factoryIds.map((facId: any) => {
        let facInfo = factoryList.value.find((p: any) => p._id === facId)
        if (!facInfo?.groups) return
        let list1: any = []

        groupList2.value = groupList2.value.concat(facInfo.groups)
        list1 = facInfo.groups

        list1 && list1.map((g: any) => {
            let machineNum = 0
            let sensorNum = 0
            let machineRun = 0
            machineNum = machineNum + (g.machines ? g.machines.length : 0)

            g.machines && g.machines.map((m: any) => {
                sensorNum = sensorNum + (m.sensors ? m.sensors.length : 0)
                if (m.workStatus && m.workStatus.wkStatus) {
                    machineRun++
                }
            })

            g.machineNum = machineNum
            g.sensorNum = sensorNum
            g.machineRun = machineRun
            g.machineRate = machineNum ? (((machineRun / machineNum) * 100).toFixed(0) + '%') : '0%'


            let noHandleNum = 0
            let warningMachineNum = 0
            g.machines && g.machines.map((m: any) => {
                let noL = noHandeleList.filter((p: any) => p.machineId === m.id)
                if (noL && noL.length) {
                    noHandleNum = noHandleNum + noL.length
                    let conditionL = [
                        { value: 0, list: [0] },
                        { value: 1, list: [1, 2] },
                        { value: 2, list: [3, 4, 5] },
                        { value: 3, list: [6, 7] },
                    ]

                    if (m.workStableStatus && m.workStableStatus.condition) {
                        let c1: any = conditionL.find((p: any) => p.list.includes(m.workStableStatus.condition))?.value
                        let c2: any = conditionL.find((p: any) => p.list.includes(noL[0].condition))?.value
                        if (c1 >= c2) {
                            warningMachineNum++
                        }
                    }
                }
            })
            g.noHandleNum = noHandleNum
            g.warningMachineNum = warningMachineNum
        })
        groList = groList.concat(list1)
    })

    let groupInfo = getGroupListByFactory()
    let groLists = groList.filter((p:any) => groupInfo.find((g:any) => g.id === p.sonID))
    groupListData.value = groLists
}

// 选择区域
let groupInfo: any = ref({ machines: [] })
let machineListShow: any = ref([])
let showSearchModel: any = ref({
    follow: null,
    codnition: null,
    status: null
})
let machine_id = ref('')
const selectGroup = async (ev: any) => {
    if (listSelectGroup.value) {
        selectModel.value = 2
        visibleChart2.value = false
        visibleChart2.value = true
        groupInfo.value = groupListData.value.find((p: any) => p.sonID === listSelectGroup.value)
        if (!groupInfo.value) {
            groupInfo.value = { machines: [] }
            machineListShow.value = []
            machineListShowPage.value = []
            return
        }

        if (groupInfo.value.machines?.length > 0) {
            getSensorList(groupInfo.value.machines[0])
            getRandarData(groupInfo.value.machines[0])
            getMachineWarningData(groupInfo.value.machines[0])
            machine_id.value = groupInfo.value.machines[0].id
        }

        getMachineListShow()
    } else {
        selectModel.value = 1
        visibleChart1.value = false
        visibleChart1.value = true
        setTimeout(() => {
            getConditionChartData()
        }, 500);
    }

}

const selectGroup2 = (ev: any) => {
    listSelectGroup.value = ev.sonID
    selectGroup(listSelectGroup.value)
}

//筛选显示设备
const getMachineListShow = () => {
    let list = JSON.parse(JSON.stringify(groupInfo.value.machines))

    if (showSearchModel.value.follow == true) {
        list = list.filter((p: any) => p.follow === showSearchModel.value.follow)
    }
    if(showSearchModel.value.follow == false) {
        list = list.filter((p: any) => !p.follow)
    }


    if (showSearchModel.value.status) {
        if (showSearchModel.value.status === 1) {
            list = list.filter((p: any) => p.workStatus && p.workStatus.wkStatus === 1)
        }
        if (showSearchModel.value.status === 2) {
            list = list.filter((p: any) => !p.workStatus || p.workStatus.wkStatus === 0)
        }
    }
    if (showSearchModel.value.codnition) {
        if (showSearchModel.value.codnition === 1) {
            list = list.filter((p: any) => !p.workStableStatus || p.workStableStatus.condition === 0)
        }
        if (showSearchModel.value.codnition === 2) {
            list = list.filter((p: any) => p.workStableStatus && p.workStableStatus.condition >= 1 && p.workStableStatus.condition <= 2)
        }
        if (showSearchModel.value.codnition === 3) {
            list = list.filter((p: any) => p.workStableStatus && p.workStableStatus.condition >= 3 && p.workStableStatus.condition <= 5)
        }
        if (showSearchModel.value.codnition === 4) {
            list = list.filter((p: any) => p.workStableStatus && p.workStableStatus.condition >= 6 && p.workStableStatus.condition <= 7)
        }
    }

    list.map((p: any) => {
        if (p.pictures?.length > 0) {
            p.url = p.pictures[0].url;
        }
    });

    machineListShow.value = list
    machineListShow.value.sort((a:any, b:any) => {return a.sort-b.sort})

    searchPage.value.total = list.length
    searchPage.value.skip = 1
    changePage(searchPage.value.skip, searchPage.value.take)
}

// 设备列表分页'
let machineListShowPage:any = ref([])
let pageSizeOptions = ref<string[]>(['5', '10', '20']);
let searchPage = ref({
    skip: 1,
    take: 10,
    total: 0
})

const changePage = (current:any, pageSize:any) => {
    machineListShowPage.value = machineListShow.value.slice((current-1)*pageSize, current*pageSize)
}


// 获取雷达图数据
const getRandarData = async (machine: any) => {
    let faultnamesSearch = {
        params: { machineId: machine.id },
        headers: {
            requestId: uuidv4(),
        },
    }
    let result = await request.get('/api/machines/faultnames', faultnamesSearch)
    let faultName = result.data.faultNames
    let faultNameII = result.data.faultNameExpects

    let Slist: any = []
    let Tlist: any = []

    if (machine.workStableStatus && machine.workStableStatus.scores) {
        for (let index in machine.workStableStatus.scores) {
            const item = machine.workStableStatus.scores[index];
            if (index.includes('S')) {
                Slist.push({
                    quota: index,
                    score: item,
                    text: langObj.value[faultName.find((p: any) => p.column === index)?.title] || faultName.find((p: any) => p.column === index)?.title
                })
            }

            if (index.includes('T')) {
                Tlist.push({
                    quota: index,
                    score: item,
                    text: langObj.value[faultNameII.find((p: any) => p.column === index)?.title] || faultNameII.find((p: any) => p.column === index)?.title,
                })
            }
        }
    }

    setTimeout(() => {
        initRandarChart(Tlist, 'chart2A')
        initRandarChart(Slist, 'chart2B')
    }, 500);
}

// 雷达图绘制
const initRandarChart = (dataList: any, id: any) => {
    const ec = echarts as any;
    const target = document.getElementById(id)
    if (!target) return
    let myChart = ec.getInstanceByDom(target) || ec.init(target);
    myChart.clear()

    if (!dataList.length) return

    let data: any = []
    let error: any = []
    let indicator: any = []
    dataList.map((d: any) => {
        data.push(d.score)
        error.push(60)
        let color = ''
        if (d.score >= 0 && d.score < 60) {
            color = '#CD5F3B'
        }
        if (d.score >= 60 && d.score < 80) {
            color = '#706a00ff'
        }
        if (d.score >= 80 && d.score <= 100) {
            color = '#fff'
        }
        let name = ''
        if((language.value == "Chinese" || language.value == "Chinese_ft") && d.text) {
        if (d.text.length > 8) {
            name = (d.text.substring(0, 4) + '\n' + d.text.substring(4, 8) + '\n' + d.text.substring(8, d.text.length))
        } else if (d.text.length > 4 && d.text.length <= 8) {
            name = d.text.substring(0, 4) + '\n' + d.text.substring(4, d.text.length)
        } else {
            name = d.text
        }
        } 

        if(language.value == "English" && d.text) {
        let list1 = d.text.split(' ')

        let str:any = ''
        let num = 0
        let sy = ''
        list1.map((n:any, i:any) => {
            if(i==0) {
            if(n.length <= 10) {
                num = n.length
                str = n
            } else {
                num = 10
                let a1 = n.substring(0,10)
                sy = n.slice(10)
                str = a1
            }
            } else {

            if(sy) {
                str = str + '\n' ;
                let n2 = sy.length + n.length
                if(n2 <= 10) {
                num = n2
                str = str + sy + ' ' + n
                sy = ''
                } else {
                num = 10
                str = str + sy
                let n2 = 10 - sy.length >=0 ? 10 - sy.length : 0

                let a1 = n.substring(0,n2)
                sy = n.slice(10)
                str = str + a1
                }
            } else {
                if(num + n.length <= 10) {
                str = str + ' ' + n
                num = num + n.length
                } else {
                str = str + '\n'  + n
                num = n.length
                }
            }
            }
        })
        name = str
        }

        indicator.push({
            color,
            max: 100,
            text:name
        })
    })

    const option = {
        title: {
            text: ''
        },
        tooltip: {
            position: { right: '-50px' }
        },
        radar: [
            {
                indicator: indicator,
                center: ['50%', '50%'],
                radius: 50,
                startAngle: 90,
                splitNumber: 5,
                axisName: {
                    formatter: '{value}',
                    fontSize: 10,
                },
                name: {
                    formatter: '{value}',
                    textStyle: {
                        color: 'rgba(46, 214, 157, 1)',
                        fontSize: 11
                    }
                },
                splitArea: {
                    areaStyle: {
                        color: [
                            '#605969',
                            '#453A47',
                        ]
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: 'rgba(255, 255, 255, 0.1)'
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: [
                            'rgb(241,243,250)'
                        ],
                        width: 0
                    }
                }
            }
        ],
        series: [
            {
                name: '当前值',
                type: 'radar',
                emphasis: {
                    lineStyle: {
                        width: 4
                    }
                },
                symbolSize: 2, // 拐点的大小
                data: [
                    {
                        value: data,
                        lineStyle: {
                            width: 1,
                            color: 'rgba(247,220,225,0.1)',
                            normal: {
                                type: 'dotted'
                            }
                        },
                        itemStyle: {
                            color: '#FF4E13',
                            borderWidth: 5
                        },
                        areaStyle: {
                            color: '#F7DCE1'
                        }
                    }
                ]
            },
            {
                name: '预警值',
                type: 'radar',
                emphasis: {
                    lineStyle: {
                        width: 1
                    }
                },
                symbolSize: 2, // 拐点的大小
                data: [
                    {
                        value: error,
                        name: '',
                        lineStyle: {
                            width: 2,
                            color: 'rgba(255, 25, 59, 0.2)'
                        },
                        itemStyle: {
                            color: 'rgba(255, 25, 59, 0.2)',
                            borderWidth: 0
                        }
                    }
                ]
            }
        ]
    }

    option && myChart.setOption(option)
    option && myChart.setOption(option);
    myChart.resize()
}

// 获取设备报警记录
let machineWarningData2: any = ref([])
const getMachineWarningData = async (machine: any) => {
    let config: any = {
        params: {
            skip: 1,
            take: 7,
            machineId: machine.id,
            typeList: [1, 4]
        },

        headers: {
            requestId: uuidv4(),
        },
    };

    let result = await request.get('/api/workflows', config)
    if (result && result.data) {
        machineWarningData2.value = result.data.list
        machineWarningData2.value.map((d: any) => {
            d.date = d.date.substring(5, 16)
        })
    }
}


//选择设备
let picList: any = ref([])
let picListAll: any = ref([])
let machine_info: any = ref({})
const selectMachine = (ev: any) => {
    machine_info.value = ev
    machine_id.value = ev.id
    getSensorList(ev)
    getRandarData(ev)
    getMachineWarningData(ev)
}

const getSensorList = async (machine: any) => {
    picList.value = [];
    if (machine.pictures?.length > 0) {
        picList.value.push({ name: machine.machineName, url: machine.pictures[0].url });
    }

    let config: any = {
        params: {
            machineId: machine.id,
        },
        headers: {
            requestId: uuidv4(),
        },
    };
    let result = await request.get("/api/sensors", config);

    if (result && result.status === 200) {
        result.data.map((d: any) => {
            if (d.pictures) {
                d.pictures.map((p: any) => {
                    picList.value.push({
                        name: d.sensorPlace,
                        url: p.url
                    })
                })

            }
        })
    }

    picListAll.value = picList.value

};



//关注、取关
const follow = async (ev: any, value: any) => {
    
    ev.follow = value
    // return
    let form = {
        machineId: ev.id,
        follow: value
    }

    let result = await request.post('/api/machines/follow', form)
    if(result?.data) {
        let info = groupInfo.value.machines.find((p:any) => p.id === ev.id)
        if(info) {
            info.follow = value
        }
    }
}


// 查看更多
const viewMore = () => {
    router.push('/warning-manage/warning-list')
}


return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_question_circle_outlined = _resolveComponent("question-circle-outlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_right_outlined = _resolveComponent("right-outlined")!
  const _component_environment_outlined = _resolveComponent("environment-outlined")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(langObj)['显示单位']) + ":", 1),
      _createVNode(_component_a_select, {
        ref: "select",
        value: _unref(listSelectFac),
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(listSelectFac) ? (listSelectFac).value = $event : listSelectFac = $event)),
        style: {"width":"120px","margin-left":"20px"},
        onChange: getGroupListDetail,
        dropdownMatchSelectWidth: false
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(factoryList), (item, index) => {
            return (_openBlock(), _createBlock(_component_a_select_option, {
              key: index,
              value: item._id
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getTranslation)(item.factoryName)), 1)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value"]),
      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "mx-4" }, ">", -1)),
      _createVNode(_component_a_select, {
        ref: "select",
        value: _unref(listSelectGroup),
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_isRef(listSelectGroup) ? (listSelectGroup).value = $event : listSelectGroup = $event)),
        style: {"width":"120px"},
        onChange: selectGroup
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupList2), (item, index) => {
            return (_openBlock(), _createBlock(_component_a_select_option, {
              key: index,
              value: item.sonID
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getTranslation)(item.name)), 1)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value"]),
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "flex-1" }, null, -1))
    ]),
    (_unref(selectModel) === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h3", _hoisted_8, _toDisplayString(_unref(langObj)['监测范围']), 1),
                _createVNode(_component_a_tooltip, { placement: "topLeft" }, {
                  title: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(langObj)['监控设备数:用户所选组织下的监测设备数统计']), 1),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(langObj)['监控测点数:用户所选组织下的监测测点数统计']), 1),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(langObj)['运行设备数:用户所选组织下的监测设备中运行设备数统计']), 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(langObj)['运行率:用户所选组织下的监测设备中运行设备数/监测设备总数']), 1)
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_question_circle_outlined, { style: {"font-size":"16px","color":"#10b981","cursor":"pointer"} })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", {
                  style: {"padding":"10px","border-radius":"8px","background":"rgb(15,15,30)","border":"1px solid #2a2a3a","box-shadow":"0 1px 3px rgba(0, 0, 0, 0.06)","transition":"all 0.2s ease"},
                  class: "metric-card hover:shadow-lg",
                  onMouseenter: _cache[2] || (_cache[2] = ($event: any) => {$event.currentTarget.style.boxShadow='0 4px 12px rgba(16, 185, 129, 0.15)'; $event.currentTarget.style.borderColor='#3a3a4a';}),
                  onMouseleave: _cache[3] || (_cache[3] = ($event: any) => {$event.currentTarget.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.06)'; $event.currentTarget.style.borderColor='#2a2a3a';})
                }, [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(langObj)['监控设备数']), 1),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(machineList).length), 1),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(getLanguage)("台", _unref(language))), 1)
                    ]),
                    _cache[24] || (_cache[24] = _createElementVNode("img", {
                      src: _imports_0,
                      style: {"width":"28px","opacity":"0.6"}
                    }, null, -1))
                  ])
                ], 32),
                _createElementVNode("div", {
                  style: {"padding":"10px","border-radius":"8px","background":"rgb(15,15,30)","border":"1px solid #2a2a3a","box-shadow":"0 1px 3px rgba(0, 0, 0, 0.06)","transition":"all 0.2s ease"},
                  class: "metric-card hover:shadow-lg",
                  onMouseenter: _cache[4] || (_cache[4] = ($event: any) => {$event.currentTarget.style.boxShadow='0 4px 12px rgba(59, 130, 246, 0.15)'; $event.currentTarget.style.borderColor='#3a3a4a';}),
                  onMouseleave: _cache[5] || (_cache[5] = ($event: any) => {$event.currentTarget.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.06)'; $event.currentTarget.style.borderColor='#2a2a3a';})
                }, [
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(langObj)['监控测点数']), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(sensorList).length), 1),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(getLanguage)("个", _unref(language))), 1)
                    ]),
                    _cache[25] || (_cache[25] = _createElementVNode("img", {
                      src: _imports_1,
                      style: {"width":"28px","opacity":"0.6"}
                    }, null, -1))
                  ])
                ], 32),
                _createElementVNode("div", {
                  style: {"padding":"10px","margin-bottom":"8px","border-radius":"8px","background":"rgb(15,15,30)","border":"1px solid #2a2a3a","box-shadow":"0 1px 3px rgba(0, 0, 0, 0.06)","transition":"all 0.2s ease"},
                  class: "metric-card hover:shadow-lg",
                  onMouseenter: _cache[6] || (_cache[6] = ($event: any) => {$event.currentTarget.style.boxShadow='0 4px 12px rgba(168, 85, 247, 0.15)'; $event.currentTarget.style.borderColor='#3a3a4a';}),
                  onMouseleave: _cache[7] || (_cache[7] = ($event: any) => {$event.currentTarget.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.06)'; $event.currentTarget.style.borderColor='#2a2a3a';})
                }, [
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(langObj)['运行设备数']), 1),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_24, _toDisplayString(getRunMachine(_unref(machineList)).num), 1),
                      _createElementVNode("div", _hoisted_25, "(" + _toDisplayString(getRunMachine(_unref(machineList)).rate) + "%)", 1)
                    ]),
                    _cache[26] || (_cache[26] = _createElementVNode("img", {
                      src: _imports_2,
                      style: {"width":"28px","opacity":"0.6"}
                    }, null, -1))
                  ])
                ], 32)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("h3", _hoisted_27, _toDisplayString(_unref(langObj)['全厂运行情况']), 1),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", {
                  style: {"padding":"16px","border-radius":"8px","background":"linear-gradient(135deg, #fef3c7 0%, #fef9e7 100%)","border":"1px solid #fde68a","box-shadow":"0 1px 3px rgba(0, 0, 0, 0.06)","transition":"all 0.2s ease","position":"relative"},
                  onMouseenter: _cache[8] || (_cache[8] = ($event: any) => ($event.currentTarget.style.boxShadow='0 4px 12px rgba(217, 119, 6, 0.15)')),
                  onMouseleave: _cache[9] || (_cache[9] = ($event: any) => ($event.currentTarget.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.06)'))
                }, [
                  _cache[30] || (_cache[30] = _createElementVNode("div", {
                    class: "status-indicator",
                    style: {"position":"absolute","bottom":"8px","right":"8px","width":"12px","height":"12px","border-radius":"50%","background-color":"#10b981","box-shadow":"0 0 8px rgba(16, 185, 129, 0.6)"}
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(langObj)['系统持续服务运行']), 1),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", null, [
                          _createTextVNode(_toDisplayString(Math.floor(_unref(totalTime) / (24 * 365))) + " ", 1),
                          _cache[27] || (_cache[27] = _createElementVNode("span", { style: {"font-size":"12px"} }, "years", -1))
                        ]),
                        _createElementVNode("div", null, [
                          _createTextVNode(_toDisplayString(Math.floor((_unref(totalTime) % (24 * 365)) / 24)) + " ", 1),
                          _cache[28] || (_cache[28] = _createElementVNode("span", { style: {"font-size":"12px"} }, "days", -1))
                        ]),
                        _createElementVNode("div", null, [
                          _createTextVNode(_toDisplayString(_unref(totalTime) % 24) + " ", 1),
                          _cache[29] || (_cache[29] = _createElementVNode("span", { style: {"font-size":"12px"} }, "hours", -1))
                        ])
                      ])
                    ]),
                    _createVNode(_component_a_tooltip, { placement: "topLeft" }, {
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_unref(langObj)['显示该系统为工厂上线运行的时间']), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_question_circle_outlined, { style: {"font-size":"16px","color":"#d97706","cursor":"pointer"} })
                      ]),
                      _: 1
                    })
                  ])
                ], 32),
                _createElementVNode("div", {
                  style: {"padding":"16px","border-radius":"8px","background":"linear-gradient(135deg, #d1fae5 0%, #ecfdf5 100%)","border":"1px solid #a7f3d0","box-shadow":"0 1px 3px rgba(0, 0, 0, 0.06)","transition":"all 0.2s ease"},
                  onMouseenter: _cache[10] || (_cache[10] = ($event: any) => ($event.currentTarget.style.boxShadow='0 4px 12px rgba(16, 185, 129, 0.15)')),
                  onMouseleave: _cache[11] || (_cache[11] = ($event: any) => ($event.currentTarget.style.boxShadow='0 1px 3px rgba(0, 0, 0, 0.06)'))
                }, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(langObj)['全厂运行设备健康分数']), 1),
                      _createElementVNode("div", _hoisted_35, [
                        _createTextVNode(_toDisplayString(_unref(weightedAverage)), 1),
                        _cache[31] || (_cache[31] = _createElementVNode("span", { style: {"font-size":"20px"} }, "%", -1))
                      ]),
                      _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(langObj)['运行中设备状态得分']), 1)
                    ]),
                    _createVNode(_component_a_tooltip, { placement: "topLeft" }, {
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(langObj)['针对运行中的设备, 状态得分的加权平均数计算为全厂健康分数, 健康设备记100分, 可用设备记80分, 警戒设备记60分, 故障设备记30分']), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_question_circle_outlined, { style: {"font-size":"16px","color":"#4b5563","cursor":"pointer"} })
                      ]),
                      _: 1
                    })
                  ])
                ], 32)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(langObj)['设备健康状态统计']), 1)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _cache[32] || (_cache[32] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                  (_unref(isShowFac))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        _createVNode(_component_a_select, {
                          ref: "select",
                          value: _unref(conditionSelectFac),
                          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (_isRef(conditionSelectFac) ? (conditionSelectFac).value = $event : conditionSelectFac = $event)),
                          style: {"width":"120px"},
                          size: "small",
                          onChange: getConditionChartData,
                          dropdownMatchSelectWidth: false
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(factoryList), (item, index) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                key: index,
                                value: item._id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.factoryName), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_45, [
                  (_unref(visibleChart1))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", {
                      class: "flex items-center",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectMachineCondition(1)))
                    }, [
                      _cache[33] || (_cache[33] = _createElementVNode("div", { style: {"width":"14px","height":"14px","background-color":"#61c08f"} }, null, -1)),
                      _createElementVNode("div", _hoisted_48, _toDisplayString(_unref(langObj)['健康']) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(conditionChartData)[0].num) + _toDisplayString(_unref(getLanguage)("台", _unref(language))), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "flex items-center mt-3",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.selectMachineCondition(2)))
                    }, [
                      _cache[34] || (_cache[34] = _createElementVNode("div", { style: {"width":"14px","height":"14px","background-color":"#706a00ff"} }, null, -1)),
                      _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(langObj)['可用']) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(conditionChartData)[1].num) + _toDisplayString(_unref(getLanguage)("台", _unref(language))), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "flex items-center mt-3",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectMachineCondition(3)))
                    }, [
                      _cache[35] || (_cache[35] = _createElementVNode("div", { style: {"width":"14px","height":"14px","background-color":"#cd5f3b"} }, null, -1)),
                      _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(langObj)['警戒']) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(conditionChartData)[2].num) + _toDisplayString(_unref(getLanguage)("台", _unref(language))), 1)
                    ]),
                    _createElementVNode("div", {
                      class: "flex items-center mt-3",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.selectMachineCondition(4)))
                    }, [
                      _cache[36] || (_cache[36] = _createElementVNode("div", { style: {"width":"14px","height":"14px","background-color":"#921e37"} }, null, -1)),
                      _createElementVNode("div", _hoisted_51, _toDisplayString(_unref(langObj)['故障']) + ":", 1),
                      _createElementVNode("div", null, _toDisplayString(_unref(conditionChartData)[3].num) + _toDisplayString(_unref(getLanguage)("台", _unref(language))), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("span", _hoisted_54, _toDisplayString(_unref(langObj)['设备报警记录']), 1)
              ]),
              _createElementVNode("div", _hoisted_55, [
                _cache[37] || (_cache[37] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                _createElementVNode("div", {
                  onClick: viewMore,
                  class: "flex items-center cursor-pointer",
                  style: {"color":"#ffffffe6"}
                }, [
                  _createElementVNode("span", null, _toDisplayString(_unref(langObj)['查看更多']), 1),
                  _createVNode(_component_right_outlined)
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, _toDisplayString(_unref(langObj)['设备名称']), 1),
                  _createElementVNode("div", _hoisted_59, _toDisplayString(_unref(langObj)['报警类型']), 1),
                  _createElementVNode("div", _hoisted_60, _toDisplayString(_unref(langObj)['严重程度']), 1),
                  _createElementVNode("div", _hoisted_61, _toDisplayString(_unref(langObj)['报警时间']), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(machineWarningData), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "w-full flex items-center",
                    key: index,
                    style: _normalizeStyle({ 'background-color': index % 2 == 0 ? '#616161ff' : '#080718ff' })
                  }, [
                    _createElementVNode("div", {
                      class: "table-info",
                      style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"},
                      title: _unref(getTranslation)(item.machineName)
                    }, _toDisplayString(_unref(getTranslation)(item.machineName)), 9, _hoisted_62),
                    _createElementVNode("div", _hoisted_63, _toDisplayString(_unref(langObj)[_unref(warningTypeList).find(p => p.value === item.type)?.label]), 1),
                    _createElementVNode("div", {
                      class: "table-info",
                      style: _normalizeStyle({ 'color': getMachineWarningName(item.condition)?.color })
                    }, _toDisplayString(_unref(langObj)[getMachineWarningName(item.condition)?.name]), 5),
                    _createElementVNode("div", _hoisted_64, _toDisplayString(item.date), 1)
                  ], 4))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("span", _hoisted_68, _toDisplayString(_unref(langObj)['区域清单']), 1)
              ]),
              _createElementVNode("div", _hoisted_69, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groupListData), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    onClick: ($event: any) => (selectGroup2(item)),
                    key: index,
                    class: "box2 mt-4 mr-4"
                  }, [
                    _createElementVNode("div", _hoisted_71, [
                      _cache[38] || (_cache[38] = _createElementVNode("div", { class: "shu" }, null, -1)),
                      _createElementVNode("div", {
                        class: "size18 ml-2",
                        title: item.name,
                        style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
                      }, _toDisplayString(_unref(getTranslation)(item.name)), 9, _hoisted_72)
                    ]),
                    _cache[40] || (_cache[40] = _createElementVNode("div", { class: "heng" }, null, -1)),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("div", _hoisted_76, _toDisplayString(_unref(langObj)['监测设备']), 1),
                            _createElementVNode("div", _hoisted_77, _toDisplayString(item.machineNum) + _toDisplayString(_unref(getLanguage)("台", _unref(language))), 1)
                          ]),
                          _createElementVNode("div", _hoisted_78, [
                            _createElementVNode("div", _hoisted_79, _toDisplayString(_unref(langObj)['监测测点']), 1),
                            _createElementVNode("div", _hoisted_80, _toDisplayString(item.sensorNum) + _toDisplayString(_unref(getLanguage)("个", _unref(language))), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_81, [
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("div", _hoisted_83, _toDisplayString(_unref(langObj)['运行设备']), 1),
                            _createElementVNode("div", _hoisted_84, _toDisplayString(item.machineRun) + _toDisplayString(_unref(getLanguage)("台", _unref(language))), 1)
                          ]),
                          _createElementVNode("div", _hoisted_85, [
                            _createElementVNode("div", _hoisted_86, _toDisplayString(_unref(langObj)['运行率']), 1),
                            _createElementVNode("div", _hoisted_87, _toDisplayString(item.machineRate), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_88, [
                          _createElementVNode("div", _hoisted_89, [
                            _createElementVNode("div", _hoisted_90, _toDisplayString(_unref(langObj)['报警设备']), 1),
                            _createElementVNode("div", _hoisted_91, _toDisplayString(item.warningMachineNum) + _toDisplayString(_unref(getLanguage)("台", _unref(language))), 1)
                          ]),
                          _createElementVNode("div", _hoisted_92, [
                            _createElementVNode("div", _hoisted_93, _toDisplayString(_unref(langObj)['未处理报警']), 1),
                            _createElementVNode("div", _hoisted_94, _toDisplayString(item.noHandleNum) + _toDisplayString(_unref(getLanguage)("条", _unref(language))), 1)
                          ])
                        ])
                      ]),
                      _cache[39] || (_cache[39] = _createElementVNode("img", { src: _imports_3 }, null, -1))
                    ])
                  ], 8, _hoisted_70))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(selectModel) === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("div", _hoisted_97, [
              _createElementVNode("div", _hoisted_98, [
                _createElementVNode("span", _hoisted_99, _toDisplayString(_unref(langObj)['设备诊断']), 1)
              ]),
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("div", _hoisted_101, [
                  _cache[41] || (_cache[41] = _createElementVNode("div", {
                    class: "ml-2",
                    style: {"border-radius":"50%","background-color":"#1cc48b","width":"16px","height":"16px"}
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_102, _toDisplayString(_unref(getLanguage)('健康')) + "：" + _toDisplayString(_unref(getLanguage)('80分以上')), 1),
                  _cache[42] || (_cache[42] = _createElementVNode("div", {
                    class: "ml-2",
                    style: {"border-radius":"50%","background-color":"#ddd246","width":"16px","height":"16px"}
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_103, _toDisplayString(_unref(getLanguage)('可用')) + "：" + _toDisplayString(_unref(getLanguage)('60~80分')), 1)
                ]),
                _createElementVNode("div", _hoisted_104, [
                  _cache[43] || (_cache[43] = _createElementVNode("div", {
                    class: "ml-2",
                    style: {"border-radius":"50%","background-color":"#cb6a34","width":"16px","height":"16px"}
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_105, _toDisplayString(_unref(getLanguage)('警戒')) + "：" + _toDisplayString(_unref(getLanguage)('30~60分')), 1),
                  _cache[44] || (_cache[44] = _createElementVNode("div", {
                    class: "ml-2",
                    style: {"border-radius":"50%","background-color":"#b81212","width":"16px","height":"16px"}
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_106, _toDisplayString(_unref(getLanguage)('故障')) + "：" + _toDisplayString(_unref(getLanguage)('30分以下')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_107, [
                _createElementVNode("div", _hoisted_108, [
                  (_unref(visibleChart2))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_109))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_110, _toDisplayString(_unref(langObj)['健康指标']), 1)
                ]),
                _createElementVNode("div", _hoisted_111, [
                  (_unref(visibleChart2))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_112))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_113, _toDisplayString(_unref(langObj)['振动指标']), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_114, [
            _createElementVNode("div", _hoisted_115, [
              _createElementVNode("div", _hoisted_116, [
                _createElementVNode("span", _hoisted_117, _toDisplayString(_unref(langObj)['设备照片']), 1)
              ]),
              _createVNode(pictureListComponent, {
                type: 4,
                picList: _unref(picListAll)
              }, null, 8, ["picList"])
            ]),
            _createElementVNode("div", _hoisted_118, [
              _createElementVNode("div", _hoisted_119, [
                _createElementVNode("span", _hoisted_120, _toDisplayString(_unref(langObj)['设备报警记录']), 1)
              ]),
              _cache[45] || (_cache[45] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
              _createElementVNode("div", {
                onClick: viewMore,
                class: "flex items-center cursor-pointer ml-4 mb-1",
                style: {"color":"#ffffffe6"}
              }, [
                _createElementVNode("span", null, _toDisplayString(_unref(langObj)['查看更多']), 1),
                _createVNode(_component_right_outlined)
              ]),
              _createElementVNode("div", _hoisted_121, [
                _createElementVNode("div", _hoisted_122, [
                  _createElementVNode("div", _hoisted_123, _toDisplayString(_unref(langObj)['设备名称']), 1),
                  _createElementVNode("div", _hoisted_124, _toDisplayString(_unref(langObj)['报警类型']), 1),
                  _createElementVNode("div", _hoisted_125, _toDisplayString(_unref(langObj)['严重程度']), 1),
                  _createElementVNode("div", _hoisted_126, _toDisplayString(_unref(langObj)['报警时间']), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(machineWarningData2), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "w-full flex items-center",
                    style: _normalizeStyle([{"color":"#fff"}, { 'background-color': index % 2 == 0 ? '#b1afafff' : '#080718ff' }]),
                    key: index
                  }, [
                    _createElementVNode("div", {
                      class: "table-info",
                      style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"},
                      title: _unref(getTranslation)(item.machineName)
                    }, _toDisplayString(_unref(getTranslation)(item.machineName)), 9, _hoisted_127),
                    _createElementVNode("div", _hoisted_128, _toDisplayString(_unref(getLanguage)(_unref(warningTypeList).find(p => p.value === item.type)?.label)), 1),
                    _createElementVNode("div", {
                      class: "table-info",
                      style: _normalizeStyle({ 'color': getMachineWarningName(item.condition)?.color })
                    }, _toDisplayString(_unref(getLanguage)(getMachineWarningName(item.condition)?.name)), 5),
                    _createElementVNode("div", _hoisted_129, _toDisplayString(item.date), 1)
                  ], 4))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_130, [
            _createElementVNode("div", _hoisted_131, [
              _createElementVNode("div", _hoisted_132, [
                _createElementVNode("span", _hoisted_133, _toDisplayString(_unref(langObj)['设备清单']), 1)
              ]),
              _createVNode(_component_a_select, {
                ref: "select",
                value: _unref(showSearchModel).follow,
                "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_unref(showSearchModel).follow) = $event)),
                style: {"min-width":"120px"},
                onChange: getMachineListShow,
                placeholder: _unref(langObj)['全部'] || '全部'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: null }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_134, [
                        _cache[46] || (_cache[46] = _createElementVNode("img", {
                          class: "picIcon",
                          src: _imports_4,
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("div", _hoisted_135, _toDisplayString(_unref(langObj)['全部']), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: true }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_136, [
                        _cache[47] || (_cache[47] = _createElementVNode("img", {
                          class: "picIcon",
                          src: _imports_4,
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("div", _hoisted_137, _toDisplayString(_unref(langObj)['关注']), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: false }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_138, [
                        _cache[48] || (_cache[48] = _createElementVNode("img", {
                          class: "picIcon",
                          src: _imports_5,
                          alt: ""
                        }, null, -1)),
                        _createElementVNode("div", _hoisted_139, _toDisplayString(_unref(langObj)['未关注']), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "placeholder"]),
              _createVNode(_component_a_select, {
                ref: "select",
                value: _unref(showSearchModel).status,
                "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_unref(showSearchModel).status) = $event)),
                style: {"width":"200px","margin-left":"10px"},
                onChange: getMachineListShow,
                placeholder: _unref(langObj)['运行状态'] || '运行状态'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: null }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(langObj)['运行状态']), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(langObj)['运行']), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(langObj)['停机']), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "placeholder"]),
              _createVNode(_component_a_select, {
                ref: "select",
                value: _unref(showSearchModel).codnition,
                "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_unref(showSearchModel).codnition) = $event)),
                style: {"width":"200px","margin-left":"10px"},
                onChange: getMachineListShow,
                placeholder: _unref(langObj)['健康状态'] || '健康状态'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select_option, { value: null }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(langObj)['健康状态']), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(langObj)['健康']), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(langObj)['可用']), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 3 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(langObj)['警戒']), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_select_option, { value: 4 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(langObj)['故障']), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "placeholder"]),
              _createElementVNode("div", _hoisted_140, [
                _createElementVNode("div", _hoisted_141, [
                  _createVNode(_component_environment_outlined, { style: {"color":"#06DEF5","font-size":"14px"} }),
                  _createElementVNode("div", _hoisted_142, _toDisplayString(_unref(getTranslation)(_unref(groupInfo).name)), 1),
                  _createElementVNode("div", _hoisted_143, "(" + _toDisplayString(_unref(langObj)['设备总数']) + ":" + _toDisplayString(_unref(groupInfo).machineNum) + _toDisplayString(_unref(langObj)['台']) + " | " + _toDisplayString(_unref(langObj)['运行数']) + ":" + _toDisplayString(_unref(groupInfo).machineRun) + _toDisplayString(_unref(langObj)['台']) + " | " + _toDisplayString(_unref(langObj)['报警设备']) + ":" + _toDisplayString(_unref(groupInfo).warningMachineNum) + _toDisplayString(_unref(langObj)['台']) + ")", 1),
                  _cache[49] || (_cache[49] = _createElementVNode("div", { class: "flex-1" }, null, -1))
                ]),
                _createElementVNode("div", _hoisted_144, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(machineListShowPage), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      onClick: ($event: any) => (selectMachine(item)),
                      key: index,
                      style: _normalizeStyle({ 'background': item.id === _unref(machine_id) ? '#1d1a2d' : '#080718ff', 'border-color': item?.workStableStatus?.condition ? getMachineWarningName(item?.workStableStatus?.condition).color : '#171325ff' }),
                      class: "box4 cursor-pointer mt-3 mr-3"
                    }, [
                      _createElementVNode("div", _hoisted_146, [
                        _cache[50] || (_cache[50] = _createElementVNode("div", { class: "shu" }, null, -1)),
                        _createElementVNode("div", {
                          class: "size14 ml-2",
                          style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"},
                          title: item.machineName
                        }, _toDisplayString(_unref(getTranslation)(item.machineName)), 9, _hoisted_147),
                        _cache[51] || (_cache[51] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                        (item.follow)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "picIcon",
                              onClick: ($event: any) => (follow(item, false)),
                              src: _imports_4,
                              alt: ""
                            }, null, 8, _hoisted_148))
                          : _createCommentVNode("", true),
                        (!item.follow)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              class: "picIcon",
                              onClick: ($event: any) => (follow(item, true)),
                              src: _imports_5,
                              alt: ""
                            }, null, 8, _hoisted_149))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[56] || (_cache[56] = _createElementVNode("div", { class: "heng" }, null, -1)),
                      _createElementVNode("div", _hoisted_150, [
                        _createElementVNode("div", _hoisted_151, [
                          _createElementVNode("img", {
                            style: {"height":"72px"},
                            src: item.url,
                            alt: ""
                          }, null, 8, _hoisted_152)
                        ]),
                        _createElementVNode("div", _hoisted_153, [
                          (item.workStatus && item.workStatus.wkStatus)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                                _cache[52] || (_cache[52] = _createElementVNode("div", { class: "line" }, [
                                  _createElementVNode("div", { class: "line animation" })
                                ], -1)),
                                _createElementVNode("span", _hoisted_155, _toDisplayString(_unref(langObj)['运行']), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_156, [
                                _cache[53] || (_cache[53] = _createElementVNode("div", { class: "down" }, [
                                  _createElementVNode("div", { class: "down animation" })
                                ], -1)),
                                _createElementVNode("span", _hoisted_157, _toDisplayString(_unref(langObj)['停机']), 1)
                              ])),
                          _createElementVNode("div", _hoisted_158, [
                            _createElementVNode("div", {
                              class: "line",
                              style: _normalizeStyle({ 'background-color': getMachineWarningName(item?.workStableStatus?.condition).color })
                            }, [
                              _createElementVNode("div", {
                                class: "line animation",
                                style: _normalizeStyle({ 'background-color': getMachineWarningName(item?.workStableStatus?.condition).color })
                              }, null, 4)
                            ], 4),
                            _createElementVNode("span", _hoisted_159, _toDisplayString(_unref(langObj)[getMachineWarningName(item?.workStableStatus?.condition).name ]), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_160, [
                        (_unref(machine_info)?.workStatus?.onLine)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_161, _toDisplayString(_unref(langObj)['累计运行']), 1))
                          : _createCommentVNode("", true),
                        (_unref(machine_info)?.workStatus?.onLine)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_162, _toDisplayString(_unref(machine_info).workStatus.onLine) + _toDisplayString(_unref(langObj)['小时']), 1))
                          : _createCommentVNode("", true),
                        _cache[54] || (_cache[54] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                        _createElementVNode("div", {
                          style: {"max-width":"110px","overflow":"hidden","white-space":"nowrap","text-overflow":"ellipsis"},
                          title: item.faultTitle
                        }, _toDisplayString(_unref(langObj)[item.faultTitle] || _unref(getLanguage)(item.faultTitle) || item.faultTitle), 9, _hoisted_163)
                      ]),
                      _createElementVNode("div", _hoisted_164, [
                        _createElementVNode("span", null, _toDisplayString(_unref(langObj)['速度均方根']), 1),
                        _createElementVNode("div", _hoisted_165, _toDisplayString(Number(item.sz)?.toFixed(2)) + "mm/s", 1),
                        _cache[55] || (_cache[55] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(langObj)['温度']), 1),
                        _createElementVNode("div", _hoisted_166, _toDisplayString(item.temp) + "℃", 1)
                      ])
                    ], 12, _hoisted_145))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_167, [
                  _createVNode(_component_a_pagination, {
                    current: _unref(searchPage).skip,
                    "onUpdate:current": _cache[20] || (_cache[20] = ($event: any) => ((_unref(searchPage).skip) = $event)),
                    "page-size": _unref(searchPage).take,
                    "onUpdate:pageSize": _cache[21] || (_cache[21] = ($event: any) => ((_unref(searchPage).take) = $event)),
                    "page-size-options": _unref(pageSizeOptions),
                    total: _unref(searchPage).total,
                    "show-size-changer": "",
                    onChange: changePage
                  }, {
                    buildOptionText: _withCtx((props) => [
                      _createElementVNode("span", null, _toDisplayString(props.value) + " records/page", 1)
                    ]),
                    _: 1
                  }, 8, ["current", "page-size", "page-size-options", "total"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})